const parseIntFromHex = (hexValue) => parseInt(`0x${hexValue}`, 16);

const splitHex = (triHexValue) => triHexValue.match(/.{1,2}/g);

export const getHexToRgb = (triHexValue) => splitHex(triHexValue.replace('#', '')).map(parseIntFromHex).join(', ');
